import api from 'ApiConfig';

const headhrService = {
  getDashboardStats: async (selectedBranch) => {
    return api.get('/headhr/dashboard-stats', {
      params: { selectedBranch },
    });
  },
  getAllHRs: async (
    selectedBranch,
    page = 1,
    limit = 100,
    filterStatus = null
  ) => {
    return api.get('/headhr/hrs', {
      params: {
        selectedBranch,
        page,
        limit,
        filterStatus,
      },
    });
  },
  createHR: async (hrData) => {
    const { name, email, password, contact, branches, hrRole, allPermission } =
      hrData;
    const formattedData = {
      placementName: name,
      placementEmail: email,
      placementPassword: password,
      contactNumber: contact,
      branches: branches?.map((b) => b.value) || [],
      hrRole: hrRole || 'hr',
      allPermission: allPermission || false,
    };
    return api.post('/headhr/create-hr', formattedData);
  },
  updateHR: async (payload) => {
    const {
      name: placementName,
      email: placementEmail,
      password: placementPassword,
      _id: placementId,
      contact: placementContact,
      branches,
      hrRole,
      allPermission,
    } = payload;
    const updatedPayload = {
      placementName,
      placementEmail,
      placementId,
      contactNumber: placementContact,
      branches: branches?.map((b) => b.value) || [],
      hrRole,
      allPermission,
    };
    if (placementPassword && placementPassword.trim() !== '') {
      updatedPayload.placementPassword = placementPassword;
    }
    return api.post('/headhr/update-hr', updatedPayload);
  },
  blockUnblockHR: async (placementId, isBlocked) => {
    return api.post('/headhr/block-hr', {
      placementId,
      isBlocked,
    });
  },
  deleteHR: async (placementId) => {
    return api.post('/headhr/delete-hr', { placementId });
  },
  getBranches: async () => {
    return api.get('/combinedroutes/get-all-branches');
  },
  getUnassignedStudents: async (selectedBranch) => {
    return api.get('/headhr/unassigned-students', {
      params: { selectedBranch },
    });
  },
  assignStudents: async (studentIds, hrId) => {
    return api.post('/headhr/assign-students', { studentIds, hrId });
  },
  unassignStudents: async (studentIds, hrId) => {
    return api.post('/headhr/unassign-students', { studentIds, hrId });
  },
  getAllStudents: async (selectedBranch, assignedHR, search) => {
    return api.get('/headhr/all-students', {
      params: {
        selectedBranch,
        assignedHR: assignedHR === 'all' ? undefined : assignedHR,
        search,
      },
    });
  },
};

export default headhrService;
